import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

import './InputWithDownload.scss';

export default class InputWithDownload extends Component {
  render() {
    const { value, template, id , files} = this.props;

    return (
      <div className={`InputWithDownload${template ? ` template-${template}` : ''}`}>
        <div className={`group-input`}>
          <Input
            id={id}
            value={value}
            readOnly
          />
          <a  className="text" href={files} download={value}>Download</a>
        </div>
      </div>
    );
  }
}

InputWithDownload.propTypes = {
  'id': PropTypes.string,
  'template': PropTypes.string,
  'value': PropTypes.string,
  'files': PropTypes.any,
};
